<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">
      <el-input :placeholder="$t('searchText.구글OTP')" v-model="otp" size="mini" style="width: 100px;" class="mr-2"></el-input>
    <el-button type="danger" size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>
		<el-button type="success" size="mini" @click="editContent(false)">{{$t('tableText.추가')}}</el-button> 
    


		<div class="ml-auto">
			<el-form inline ref="form" :model="searchform">
       
        <el-form-item class="mb-0">
             <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:120px;" >
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
				

					<el-form-item class="mb-0">
						 <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:100px;"></el-input>
					</el-form-item>
					<el-form-item  class="mb-0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px;">
						    </el-date-picker>
					</el-form-item>
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
					</el-form-item>
			</el-form>
       
		 
		
			
    		
		</div>
	
	</div>

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange" :row-style="tableRowClassName">
        <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
        <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*30-scope.$index}}</template>
        </el-table-column>

        <el-table-column
        v-if="this.sitetype==4 && this.userid=='admin'"
        :label="$t('tableText.알본사')" prop="admin_id" align="center">
         <template slot-scope="scope">
            {{scope.row.admin_id}}
          </template>
      </el-table-column> 

        <el-table-column
        
        label="도메인" prop="domain" align="center" >
        
      </el-table-column> 

      <el-table-column
        
        :label="$t('msg.제목')" prop="title" align="center">
         <template slot-scope="scope">
              <el-button type="text" @click="editContent(scope)">{{scope.row.title}}</el-button>
          </template>
      </el-table-column> 

        <el-table-column
        
        :label="$t('tableText.위치')" prop="left_" align="center" >
        <template slot-scope="scope">
          x:{{scope.row.left_}} y:{{scope.row.top_}} w:{{scope.row.width_}} h:{{scope.row.height_}}
        </template>
      </el-table-column>


       <el-table-column
        
        :label="$t('tableText.추가시간')" prop="add_time" align="center">
        
      </el-table-column> 
       <el-table-column
        
        :label="$t('tableText.유효기간')" prop="s_time" align="center">
         <template slot-scope="scope">
          {{scope.row.s_time}} ~ {{scope.row.e_time}}
        </template>
      </el-table-column> 

        <el-table-column
        
        :label="$t('tableText.상태')" prop="init" align="center" >
         <template slot-scope="scope">
          {{iconObj[scope.row.init]}}
        </template>
      </el-table-column> 


    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
        <el-dialog
          :title="$t('status.편집')"
          :visible.sync="creatModel"
          :width="dWidth" :close-on-click-modal ="false">

          <el-form ref="form" :model="form" label-width="80px" v-loading="loading" :rules="rules">
           <div class="d-flex" style="justify-content:space-between;">
          
          <el-form-item v-if="this.sitetype==4 && this.userid=='admin'"  prop="admin_id" class="mb-2">
           <span class="mr-2">{{$t('status.알본선택')}}</span>
               <el-select v-model="form.admin_id"  style="width: 110px;" class="mr-2">
               <el-option
                      v-for="item in adminlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
               </el-form-item>

            <el-form-item  prop="title" class="mb-2 formTitle text-right" style="width: 65%;">
            
               
              <span class="mr-2" style="margin-left:-70px">{{$t('msg.제목')}}</span>
              <el-input   v-model="form.title" :placeholder="$t('msg.제목입력')"></el-input>
         
            </el-form-item>
          </div>
            <el-form-item label="도메인"  class="mb-0">
               <el-input  v-model="form.domain" style="width:85%"></el-input>
                <el-tooltip class="item" effect="dark" :content="$t('msg.여러도메인경우콤마로연결해주세요')" placement="right-end">
              <el-button icon="el-icon-warning" circle></el-button>
             </el-tooltip>
            </el-form-item>
           <el-form-item :label="$t('msg.내용')"  prop="contentString" class="mb-2">
            <!-- 富文本编辑器 -->   
                 <quill-editor 
                                v-model="form.contentString" 
                                ref="myQuillEditor" 
                                :options="editorOption" 
                                @blur="onEditorBlur($event)" 
                                @focus="onEditorFocus($event)"
                              @change="onEditorChange($event)">
                      </quill-editor>
                      <input type="file" @change="change" id="upload" style="display:none;" />
          </el-form-item>
            <el-form-item :label="$t('msg.유효기간')" prop="stime" class="mb-0" >
               <el-date-picker
                  v-model="form.stime"
                  type="daterange"
                  range-separator="~"
                   :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="medium" class="mr-2" value-format="yyyy-MM-dd" style="width: 254px;">
                </el-date-picker>
           
            </el-form-item>
          <el-form-item :label="$t('msg.사용')" prop="left_"  class="mb-0">
              <div class="d-flex">
                <el-select v-model="form.init" :placeholder="$t('status.선택')" size="medium" style="width:120px;">
                 <el-option
                        v-for="item in initList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                </el-select>
                <el-checkbox true-label="1" false-label="0" v-model="form.gubun" style="margin: 2px 5px 0 5px;" size="medium" :label="$t('msg.로그인팝업')" border></el-checkbox>
           게시판ID  <el-input  v-model="form.NID" style="width: 245px;" size="medium" class="ml-1" placeholder="*게시판ID입력시 클릭시이동"></el-input>
           </div>
            </el-form-item>
         
         
             <el-form-item :label="$t('tableText.위치')" prop="left_"  class="mb-0">
              <div class="d-flex">
              left<el-input  v-model="form.left_" style="width: 100px;" size="mini" class="ml-2 mr-2" type="number"></el-input>
              top<el-input  v-model="form.top_" style="width: 100px;" size="mini" class="ml-2 mr-2" type="number"></el-input>
              width<el-input  v-model="form.width_" style="width: 100px;" size="mini" class="ml-2 mr-2" type="number"></el-input>
              height<el-input  v-model="form.height_" style="width: 100px;" size="mini" class="ml-2" type="number"></el-input>
           </div>
           <div class="text-danger" style="height:24px;line-height:24px">left 왼쪽좌표.top 우측좌표.width팝업넓이(실제이미지보다 2+). heigth팝업높이(실제이미지보다 40+). </div>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button type="success" @click="test">{{$t('msg.테스트')}}</el-button>
             <el-button @click="creatModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="submit">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>
           <div class="testContainer" v-if="testVisible" :style="{width:twidth + 'px',height:theight - 32 + 'px',top:ttop + 'px',left:tleft + 'px'}">
        <div class="testClose">
          <el-button icon="el-icon-error" circle @click="closeTest"></el-button>
        </div>
       <p v-html="testnr"></p>
      </div>
        
				
</div>
 </template>

 <script>

 import { quillEditor, Quill  } from "vue-quill-editor";
Quill.register('modules/ImageExtend', ImageExtend)
import {ImageExtend, QuillWatch } from "quill-image-extend-module"
import "quill/dist/quill.core.css"; 
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
      
      
    export default {
     components: {
      quillEditor
    },
    	data(){
    		return{
            ttop:'',
          tleft:'',
          twidth:'',
          theight:'',
          testnr:'',
          testVisible:false,
            iconObj:{
               '0':'미사용',
              '1':'사용',
             
          
             
            },
           dWidth:'800px',
           editorOption: {
            placeholder:this.$i18n.t("status.편집"),
            modules:{
            
              toolbar: {
                container:[
                     ['bold', 'italic', 'underline', 'strike'],  
                     [{'header': 1}, {'header': 2}, {'header': 2}],
                     [{'list': 'ordered'}, {'list': 'bullet'}], 
                     ["image",'video','link'],
                     [{'color': []}, {'background': []}],
                     [{'size': ['small', false, 'large', 'huge']}],
                     
                ],
                 handlers: {
                    image(value) {
                      if (value) {
                        
                        document.querySelector('#upload').click()
                      } else {
                        this.quill.format('image', false)
                      }
                    },
                  },

              },
            },
             
            },
           adminlist:[{
                label:this.$i18n.t("status.선택"),
                value:''
            },
            
            ],
          html:'',
            initList:[
                
            {
              label:this.$i18n.t("msg.사용안함"),
              value:'0'
            },
             {
              label:this.$i18n.t("msg.사용"),
              value:'1'
            },
            

            ],
          html:'',
          otp:'',
         
        mtype:{"g_g4":this.$i18n.t("nav.공지사항"),"g_g3":this.$i18n.t("nav.변동정보"),"event":this.$i18n.t("nav.이벤트"),"faq":"FAQ"},
            headers:{ 'Authorization': 'Bearer ' + window.sessionStorage.getItem('user') },
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
           userid:window.sessionStorage.getItem('userid'),
    		  form:{
            id:'',
            title:'',
            contentString:'',
            stime:[],
            left_:'',
            top_:'',
            width_:'',
            height_:'',
            gubun:'',
            init:'',
            admin_id:'',
            NID:'',
            domain:''
          

          },
    			searchform:{
    				keyword:'',
    				time:[],
    				searchOptions:[
                
    				{
		          label:this.$i18n.t("msg.제목"),
		        	value:'subject'
		        },{
              label:this.$i18n.t("msg.알본"),
              value:'admin_id'
            }
            

		        ],
		       searchOptions1:[
                
           {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
             {
              label:this.$i18n.t("nav.공지사항"),
              value:'g_g4'
            }
            ],
            
		        value:'',
            value1:'g_g4',
          

      


    			},
    			 pickerOptions: {
    			},
         shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
    
      
    			
		        
    		
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
			         currentPage:1,
			         multipleSelection:[],
               rules: {

                //  admin_id:[{ required: true, message: '', trigger: 'blur'}],
                  title:[{ required: true, message: '', trigger: 'blur'}],
                  contentString:[{ required: true, message: '', trigger: 'blur'}],
                  left_:[{ required: true, message: '', trigger: 'blur'}],
                  stime:[{ required: true, message: '', trigger: 'blur'}],
                },
			        
			         
			 
    			}
    			
    			
    		},
    		created() {
    			if(this.sitetype=="2" || this.sitetype=="3")
          {
             
              this.searchOptions1=[
                 {
                   label:this.$i18n.t("msg.전체"),
                   value:''
                 },
                 {
                   label:this.$i18n.t("nav.공지사항"),
                   value:'g_g4'
                 },
                 {
                   label:this.$i18n.t("nav.변동정보"),
                   value:'g_g3'
                 }
                
              ];
         }else if(this.sitetype=="4")
         {
            

              this.searchOptions1=[
                 {
                   label:this.$i18n.t("msg.전체"),
                   value:''
                 },
                 {
                   label:this.$i18n.t("nav.공지사항"),
                   value:'g_g4'
                 },
                 {
                   label:this.$i18n.t("nav.이벤트"),
                   value:'event'
                 },
                 {
                   label:'FAQ',
                   value:'faq'
                 }
                
              ];
         }else
         {

         }

    			this.getList();
    			
			
		},
   
    	methods:{

      change(e) {
          let token=window.sessionStorage.getItem('user');
          let file = e.target.files[0]
          const formData = new FormData()
          formData.append('file', file)
          this.$axios({
　　　　　　　　　　url: this.domain+'/admin/fileu',
　　　　　　　　　　method: 'post',
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
　　　　　　　　　　data: formData,
　　　　　　　　　
　　　　　　　　}).then((url) => {
                    console.log('url:',url.data.data)
                     const quill = this.$refs.myQuillEditor.quill
                      quill.focus()
                      quill.insertEmbed(quill.getSelection().index, 'image', url.data.data)
                            　　　　　　　　　　
　　　　　　　　　
　　　　　　　　}).catch(err => {
          console.error(err)
        })

    
    },
      closeTest(){
      this.testVisible = false
    },
    test(){
      this.testVisible = true
      this.testnr =this.form.contentString 
      this.twidth = this.form.width_
      this.theight = this.form.height_
      this.ttop = this.form.top_
      this.tleft= this.form.left_
    },

          onEditorReady(editor) { // 准备编辑器
        },
          onEditorBlur(){}, // 失去焦点事件
          onEditorFocus(){}, // 获得焦点事件
          onEditorChange(event){
              // console.log(event.html)
               this.form.contentString = event.html
          }, // 内容改变事件
        tableRowClassName({row, rowIndex}) {
            let rowbackgroundbg = {};
            if(row.stick == '1'){
              rowbackgroundbg.background = '#ebeef5';
              return rowbackgroundbg;
            }
      },
    
        editContent(e = false){
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/bubonlist_select?type=bossnull&admin=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
           let newids=[];

            let obj={};
            obj.label=this.$i18n.t("msg.없음")
            obj.value=''
            newids.push(obj); 

         

            newids=[];

            


            response.data.admin.forEach(item=>{
            let obj={};
            obj.label=item.name
            obj.value=item.name
            newids.push(obj);            
           });


           

           this.adminlist=newids
    
            }).catch((error) =>{
              
            })
          //tianjia
          if(!e){
            this.form = {
   
                contentString:'',
                title:'',
                stime:[],
                left_:'',
                top_:'',
                width_:'',
                height_:'',
                init:'1',
                domain:'',
                gubun:''
                 }
             this.editIndex = -1

          }
          else{
             //修改
            this.loading = true
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/alert?id='+e.row.id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
                  this.loading = false
                  let item = response.data.data
                  console.log('data==',item.left_)

                    this.form = {
                          id:item.id,
                          title:item.title,
                          gubun:item.gubun,
                          init:item.init,
                          contentString:item.contentString,
                          domain:item.domain,
                          left_:item.left_,
                          top_:item.top_,
                          NID:item.NID,
                          width_:item.width_,
                          height_:item.height_,
                          stime:[item.s_time,item.e_time],
                           admin_id:item.admin_id      

                }
                this.editIndex = e.$index
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })


          }
        
          this.creatModel = true
         
        },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	this.$message(this.$i18n.t("msg.검색타이틀선택하세요"),);
                	 return;
                }

              this.currentPage=1;
            


    			this.getList();
    			
             

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
       
    		getList(){

    		  // console.log(this.searchform.value) 
            //   console.log(this.searchform.keyword) 
            //   console.log(this.searchform.time) 
             

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/alertlist?type='+this.searchform.value1+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                   //  console.log('tableData=',response.data.data.data)
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    	
    		  submit(){
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;
          
             //添加提交
              if (this.editIndex === -1) {
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/alert_insert',
                        data:{
                          contentString:this.form.contentString,
                          domain:this.form.domain,
                          id:this.form.id,
                          title:this.form.title,
                          admin_id:this.form.admin_id,
                          gubun:this.form.gubun,
                          init:this.form.init,
                          left_:this.form.left_,
                          top_:this.form.top_,
                          width_:this.form.width_,
                          height_:this.form.height_,
                          s_time:this.form.stime[0],
                          e_time:this.form.stime[1],
                          NID:this.form.NID
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message.error({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message.success(this.$i18n.t("msg.완료"),);
                               //console.log(this.form);
                               this.getList();
                               //this.tableData.unshift(this.form)
                               //关闭
                     this.creatModel = false

                            }
                           this.loading =false
                     
                  }).catch((error) =>{
                      this.loading =false
                  })
              
            }else{

              //console.log(this.html)
              //return;
              
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/alert_up',
                      data:{
                          contentString:this.form.contentString,
                          domain:this.form.domain,
                          id:this.form.id,
                          admin_id:this.form.admin_id,
                          title:this.form.title,
                          left_:this.form.left_,
                          gubun:this.form.gubun,
                          init:this.form.init,
                          top_:this.form.top_,
                          width_:this.form.width_,
                          NID:this.form.NID,
                          height_:this.form.height_,
                          s_time:this.form.stime[0],
                          e_time:this.form.stime[1],
                         
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                   if(response.data.code==200){
                       this.creatModel = false
                       this.$message({
                         message:this.$i18n.t("msg.수정완료"),
                          type:'success'
                      })   
                    }else
                    {
                       this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })  
                    }
                    this.getList()
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })

            }
            })
              
            
        },
    	handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
        // 批量删除
      deleteAll(){
         this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"),this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          //console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            //console.log('id',item.idx);
            newids.push(item.id);
           });

          // console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{id:newids,opt:this.otp},
                      url:this.domain+'/admin/alert_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },  
    		
    	}
  }
</script>

 <style scoped>
>>>.el-table  tr.el-table__row:hover td.el-table__cell{
  background: none !important;
}
>>>.el-dialog__body{
  padding: 10px 20px;
}
>>>.ql-editor{
  height: 300px;
}
>>>.ql-snow .ql-picker{
  height: auto;
}
.testContainer{
  background:#000;position:absolute;z-index:3000000;color:#fff;top:0;padding:0px;
}
.testClose{
  position:absolute;right:-30px;color:#000;top:-30px;background:transparent;
}
.testClose .el-button.is-circle{
  padding:10px;font-size:40px !important
}
>>>.el-button.is-circle{
      padding: 3px;
    background: transparent;
    border: none;
    color: #000 !important;font-size: 24px !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/alert/list.vue